import axios from '../utils/axios'

export function certificate_interface(params) {//
  axios.defaults.baseURL = ''
  return axios.post('http://zscx.kxcbzx.com/index/index/certificate_interface', params);
}
